import { Calendar } from './components/Calendar/Calendar'
import logoUrl from './assets/luckys-place-square.png'
import { AccountPanel } from './components/AccountPanel'
import { ThemeToggle } from './components/ThemeToggle'
import { ExternalTab } from './components/ExternalTab'
import { TabBar } from './components/TabBar'
import { TABS, type TabId } from './config'
import { useSync } from './context/SyncContext'
import { useMediaQuery } from './hooks/useMediaQuery'
import { useState } from 'react'

export default function App() {
  const { settings, setActiveTab, statusLabel } = useSync()
  const themeClass = settings.theme === 'light' ? ' app--light' : ' app--dark'
  const activeId = (TABS.some((t) => t.id === settings.activeTab)
    ? settings.activeTab
    : 'kalender') as TabId
  // Phone portrait OR phone landscape (wide but short) stay in mobile chrome
  const isNarrow = useMediaQuery('(max-width: 900px)')
  const isLandscapePhone = useMediaQuery(
    '(orientation: landscape) and (max-height: 560px)',
  )
  const isMobile = isNarrow || isLandscapePhone
  const isLandscape = useMediaQuery('(orientation: landscape)')
  const [accountOpen, setAccountOpen] = useState(false)
  const activeTab = TABS.find((t) => t.id === activeId) ?? TABS[3]

  return (
    <div
      className={`app${isMobile ? ' app--mobile' : ' app--desktop'}${
        isLandscape ? ' app--landscape' : ' app--portrait'
      }${themeClass}${accountOpen ? ' app--account-open' : ''}`}
    >
      <div className="app__scanlines" aria-hidden />
      <div className="app__grid" aria-hidden />

      <header className="app__header">
        <div className="brand">
          <img className="brand__logo" src={logoUrl} alt="" width={40} height={40} />
          <div className="brand__text">
            <span className="brand__name">Lucky's Place</span>
            <span className="brand__tag">Hasenbau 🥕</span>
          </div>
        </div>
        {!isMobile && (
          <TabBar
            tabs={TABS}
            activeId={activeId}
            onSelect={setActiveTab}
            position="top"
          />
        )}
        <ThemeToggle />
        <AccountPanel onOpenChange={setAccountOpen} />
      </header>

      <main className="app__main" role="tabpanel">
        {TABS.map((tab) => {
          if (tab.type === 'calendar') {
            return (
              <div
                key={tab.id}
                className="pane"
                hidden={activeId !== tab.id}
                style={{ display: activeId === tab.id ? 'flex' : 'none' }}
              >
                <Calendar />
              </div>
            )
          }
          return (
            <div
              key={tab.id}
              className="pane"
              style={{ display: activeId === tab.id ? 'flex' : 'none' }}
            >
              <ExternalTab
                url={tab.url!}
                label={tab.label}
                tabId={tab.id}
                active={activeId === tab.id}
              />
            </div>
          )
        })}
      </main>

      {isMobile && (
        <TabBar
          tabs={TABS}
          activeId={activeId}
          onSelect={setActiveTab}
          position="bottom"
        />
      )}

      <footer className="app__status mono" aria-hidden>
        <span>{statusLabel}</span>
        <span>{activeTab.label}</span>
        <span>v1.1</span>
      </footer>
    </div>
  )
}
